import { render, staticRenderFns } from "./NewDirectReInsuranceDetails.vue?vue&type=template&id=01e9e186&scoped=true&"
import script from "./NewDirectReInsuranceDetails.vue?vue&type=script&lang=js&"
export * from "./NewDirectReInsuranceDetails.vue?vue&type=script&lang=js&"
import style0 from "./NewDirectReInsuranceDetails.vue?vue&type=style&index=0&id=01e9e186&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e9e186",
  null
  
)

export default component.exports